import React from 'react'

const DailyInputField=({handleChange})=>{

    return (
        <div className="input-field col s6">
            <input type="date" id='date' onChange={handleChange} />
         
       </div>
    )
}

export default DailyInputField
